import React from 'react'
import { Link } from 'react-router-dom'
import { Button, ButtonVariant } from '@local/do-secundo-button'
import { t } from '@local/translations'
import { useRestaurant } from '@local/do-secundo-restaurant-provider'

export const BackToMenuButton = ({ className }: { className?: string }) => {
  const { getRestaurantPath } = useRestaurant()
  return (
    <Link to={getRestaurantPath()} className={className}>
      <Button data-testid='back-to-menu-button' variant={ButtonVariant.LINK}>
        {t('back-to-menu-button.text')}
      </Button>
    </Link>
  )
}
